/* HERO CALC END */
let resizeTimeout;
  document.addEventListener('DOMContentLoaded', function() {
    const isCart = window.location.href.includes('cart') || window.location.href.includes('products');
    setProdSize();
    observeAddToOrderBtn();

    if (!isCart) {
      hideSpecificElements();
      deleteOldestRecordIfNeeded('kl-onsite-modules', 'kl-event-cache', 10);
    }
  });

window.addEventListener('load', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(setProdSize, 100);
});


window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(setProdSize, 100);
});


function setProdSize() {
  const elements = document.querySelectorAll('.prod-size');
  elements.forEach(element => {
    const width = element.getBoundingClientRect().width;
    const currentHeight = parseFloat(getComputedStyle(element).height);

    if (currentHeight !== width) {
      element.style.height = `${width}px`;
    }
  });
}

function observeAddToOrderBtn() {
  const observer = new MutationObserver((mutations, observer) => {
    const addToOrderBtn = document.getElementById('add_to_orderno');
    
    if (addToOrderBtn) {
      addToOrderBtn.addEventListener('click', async function () {
        const orderno = document.getElementById('orderno').value;
        const updateData = {
          updates: {
            12733761028173: orderno && !addToOrderBtn.classList.contains('existing') ? 1 : 0
          }
        };

        const maxRetries = 3;
        const retryDelay = 1000;

        async function fetchWithRetries(url, options, retries = maxRetries) {
          try {
            const response = await fetch(url, options);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          } catch (error) {
            if (retries > 0) {
              console.warn(`Fetch failed, retrying in ${retryDelay}ms...`, error);
              await new Promise(resolve => setTimeout(resolve, retryDelay));
              return fetchWithRetries(url, options, retries - 1); // Retry recursively
            } else {
              throw error; // No retries left, throw error
            }
          }
        }

        try {
          const responseData = await fetchWithRetries(ShopRoutes("cart_update_url", ".js"), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updateData)
          });

          if (orderno && !addToOrderBtn.classList.contains('existing')) {
            document.cookie = `order_number=${orderno}; path=/;`;
          }

          location.reload();
        } catch (error) {
          console.error('Error updating cart after retries:', error);
        }
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}


function deleteOldestRecordIfNeeded(dbName, storeName, maxRecords) {
    const request = indexedDB.open(dbName);

    request.onsuccess = function (event) {
        const db = event.target.result;
        const transaction = db.transaction(storeName, 'readwrite');
        const store = transaction.objectStore(storeName);
        const countRequest = store.count();

        countRequest.onsuccess = function () {
            if (countRequest.result > maxRecords) {
                const cursorRequest = store.openCursor(null, 'next');

                cursorRequest.onsuccess = function (event) {
                    const cursor = event.target.result;
                    if (cursor) {
                        store.delete(cursor.key);
                        console.log(`Deleted record with key ${cursor.key}`);
                    }
                };
            } else {
                console.log(`Database size within limit: ${countRequest.result} records.`);
            }
        };

        countRequest.onerror = function () {
            console.error("Failed to count records:", countRequest.error);
        };
    };

    request.onerror = function (event) {
        console.error(`Failed to open database '${dbName}':`, event.target.error);
    };
}

function hideSpecificElements() {
    const sitesToHide = ['mygreetings'];
    const url = window.location.href;
    const shouldHide = sitesToHide.some(value => url.endsWith(value))
    const logoCarousel = document.getElementById('shopify-section-logo-carousel');
    if(logoCarousel && shouldHide) {
        logoCarousel.style.display = 'none';
    }

    const ctaElement = document.getElementById('shopify-section-CTA-myselfie');
    if(ctaElement) {
      ctaElement.style.display = 'none';
    }
}

window.addEventListener('load', function() {
  (function() {    
    var inputList = document.querySelectorAll('input[name="return_to"]');
    
    if (inputList.length > 0) {

      if (window.location) {
        if (window.location.search) {
          if (window.location.search.length > 0) {
            inputList.forEach(function(item) {

              var oldText = item.value;

              item.value = oldText + window.location.search; 
            });
          }
        }
      }
    }
  })();
});